import React, { ReactNode } from 'react';
import styled from 'styled-components';

const Label = styled.label`
    font-size: 0.75em;
    font-weight:700;
    margin-bottom: 0px;
`

const LabeledWrapper = styled.div`
    padding: 5px 15px;
`
interface LabeledProps {
    children?: ReactNode,
    labelText: string
};

const LabeledComponent = ({ children, labelText}: LabeledProps) => {
    return(
        <LabeledWrapper>
            <Label>{labelText}</Label>
            <div>{children}</div>
        </LabeledWrapper>
    )
}

export default LabeledComponent;